<template>
    <v-app>
        <v-app-bar dark color="#3949AB" app></v-app-bar>
        <v-main>
            <v-container fill-height>
                <v-card class="mx-auto" min-width="100%" min-height="100%" outlined elevation="5">
                    <!--<v-row justify="center" class="display-2">パスワード{{this.$route.params.title}}</v-row>-->
                    <v-card-title primary-title class="justify-center">
                        パスワード{{this.$route.params.title}}
                    </v-card-title>
                    <v-divider class="mx-4"></v-divider>
                    <v-card-text>
                        <v-row class="text-center" justify="center">
                            <v-form v-model="valid" ref="form" lazy-validation>
                                <v-alert v-if="error != ''"
                                         color="red"
                                         text>{{this.error}}</v-alert>
                                <v-alert v-if="send && error == ''"
                                         color="blue"
                                         text>認証コードを送信しました</v-alert>
                                <v-col cols="50">
                                    <v-text-field label="社員番号"
                                                  v-model="username"
                                                  :counter="10"
                                                  maxlength="10"
                                                  :rules="[GlobalRules.required,
                                                GlobalRules.employee_id]"
                                                  required
                                                  prepend-icon="mdi-account-circle"></v-text-field>
                                </v-col>
                                <v-col cols="50" v-if="send">
                                    <v-text-field label="認証コード"
                                                  v-model="authCode"
                                                  :counter="6"
                                                  maxlength="6"
                                                  :rules="[GlobalRules.required,
                                                GlobalRules.authcode]"
                                                  required
                                                  prepend-icon="mdi-account-check"></v-text-field>
                                </v-col>
                                <v-col cols="50" v-if="send">
                                    <v-text-field label="新しいパスワード"
                                                  v-model="password"
                                                  :counter="20"
                                                  maxlength="20"
                                                  :rules="[GlobalRules.required,
                                                GlobalRules.hanSpec,
                                                GlobalRules.more_8,
                                                GlobalRules.required_lowercase,
                                                GlobalRules.required_uppercase,
                                                GlobalRules.required_number,
                                                GlobalRules.required_spec]"
                                                  required
                                                  v-bind:type="showPassword ? 'text':'password'"
                                                  v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                  prepend-icon="mdi-lock"
                                                  @click:append="showPassword=!showPassword"></v-text-field>
                                </v-col>
                                <v-col cols="50" v-if="send">
                                    <v-text-field label="パスワード確認"
                                                  v-model="confPassword"
                                                  :counter="20"
                                                  maxlength="20"
                                                  :rules="[GlobalRules.required,
                                                GlobalRules.hanSpec,
                                                GlobalRules.more_8,
                                                GlobalRules.required_lowercase,
                                                GlobalRules.required_uppercase,
                                                GlobalRules.required_number,
                                                GlobalRules.required_spec]"
                                                  required
                                                  v-bind:type="showConfPassword ? 'text':'password'"
                                                  v-bind:append-icon="showConfPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                  prepend-icon="mdi-lock"
                                                  @click:append="showConfPassword=!showConfPassword"></v-text-field>
                                </v-col>
                                <v-card-actions>
                                    <v-btn color="blue"
                                           outlined
                                           block
                                           :disabled="!valid"
                                           v-if="!send"
                                           @click="forgetPass(username)">送信</v-btn>
                                    <v-btn color="blue"
                                           outlined
                                           block
                                           :disabled="!valid"
                                           v-if="send"
                                           @click="resetPass(username,password,authCode)">{{this.$route.params.title}}</v-btn>
                                </v-card-actions>
                                <div class="pt-8 pb-4">
                                    <span v-if="send">認証コードが届かない場合。</span>
                                    <router-link v-if="send"
                                                 v-on:click.native=resetData()
                                                 :to="{name:'ResetPass',params:{title:'発行'}}">こちら</router-link>
                                    <p></p>
                                    <router-link :to="{name:'Signin'}">サインイン画面</router-link>
                                </div>
                            </v-form>
                        </v-row>
                    </v-card-text>
                </v-card>
                    

            </v-container>
        </v-main>
        <v-footer dark color="#3949AB" style="height: 3%;" app></v-footer>
    </v-app>
</template>

<script>export default {
        name: 'ResetPass',

        data: () => ({
            showPassword: false,
            showConfPassword: false,
            valid: false,
            error: "",
            send: false,
            authCode: "",
            username:"",
            password: "",
            confPassword: "",
        }),

        methods: {
            //パスワードをリセットする
            resetPass(username, password, authCode) {
                if (password == this.confPassword) {
                    this.$cognito.resetPassword(username, password, authCode)
                        .then(result => {
                            //console.log("成功")
                            //console.log({ result })
                            this.$router.push('/')

                        })
                        .catch(err => {
                            console.log(err.code)
                            if (err.code == 'NetworkError') {
                                this.error = 'ネットワークに接続してください'
                            } else if (err.code == 'LimitExceededException') {
                                this.error = 'しばらく時間をあけてください'
                            } else if (err.code == 'CodeMismatchException') {
                                this.error = '認証コードに誤りがあります'
                            } else {
                                this.error = this.$route.params.title + 'できませんでした。入力内容を確認してください'
                            }
                        })
                } else { this.error = 'パスワードの入力内容を確認してください。'}
            },

            //認証コードを送信する
            forgetPass(username) {
                this.$cognito.forgetPassword(username)
                    .then(result => {
                        //console.log("成功")
                        //console.log(result)
                        this.send = true
                        this.error = ""
                    })
                    .catch(err => {
                        console.log(err.code)
                        if (err.code == 'NetworkError') {
                            this.error = 'ネットワークに接続してください'
                        } else if (err.code == 'LimitExceededException') {
                            this.error = 'しばらく時間をあけてください'
                        } else {
                            this.error ='送信できませんでした。入力内容を確認してください'
                        }
                    })
            },

            resetData() {
                this.error = ""
                this.send = false
                this.authCode = ""
                this.username = ""
                this.password = ""
                this.confPassword = ""
            }
        }
    }</script>